import { render, staticRenderFns } from "./HomeLoadingScreen.vue?vue&type=template&id=068fe56e&scoped=true&"
import script from "./HomeLoadingScreen.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HomeLoadingScreen.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068fe56e",
  null
  
)

export default component.exports